import {BaseComparator, Result, ResultState} from './BaseComparator';

abstract class SimpleStringComparator implements BaseComparator<string> {
    protected constructor() {

    }

    compare(guess: string, actual: string): Result {
        if (guess === actual) {
            return {state: ResultState.MATCH};
        } else {
            return {state: ResultState.FAR}
        }
    }
}

export {SimpleStringComparator};
